export const ALL_LOCATIONS = 'All Locations';
export const ALL_EVENTS = 'All Events';
export const CLUB_EAGLERIDER_RIDES = 'Club EagleRider Rides';
export const DEFAULT_EVENTS_COUNT = 12;
